import(/* webpackMode: "eager" */ "/vercel/path0/Frontend/src/components/nav/MainComponent.jsx")